import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Hurtig start',
  description: 'Gennemgå denne guide for at komme hurtigst muligt i gang med lanceringen',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Notifikationspræference',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Åbningstider og placering',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Restaurantens identitet',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Bestillingsindstillinger',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Menuopsætning',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing og loyalitet',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Min butik',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Gå live',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Fuldført',
  },
  toasts: {
    failed_to_load_onboarding: 'Onboarding-trin kunne ikke indlæses',
  },
};
